module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_power_outage_black.46869201.png";